var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationInformationMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9379_10009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 16H6.66667V17.3333H25.3333V16Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 10.6667C31.402 10.6667 32 10.0687 32 9.33333V6.66667C32 5.93133 31.402 5.33333 30.6667 5.33333H28.8L27.002 0.838C26.7993 0.332 26.3093 0 25.764 0H6.236C5.69067 0 5.20067 0.332 4.998 0.838L3.2 5.33333H1.33333C0.598 5.33333 0 5.93133 0 6.66667V9.33333C0 10.0687 0.598 10.6667 1.33333 10.6667H2.66667V30.6667H0V32H32V30.6667H29.3333V10.6667H30.6667ZM6.236 1.33333H25.764L27.364 5.33333H4.636L6.236 1.33333ZM1.33333 9.33333V6.66667H30.6667L30.6673 9.33333H1.33333ZM8 30.6667V21.3333H13.3333V30.6667H8ZM18.6667 30.6667V21.3333H24V30.6667H18.6667ZM28 30.6667H25.3333V21.3333C25.3333 20.598 24.7353 20 24 20H18.6667C17.9313 20 17.3333 20.598 17.3333 21.3333V30.6667H14.6667V21.3333C14.6667 20.598 14.0687 20 13.3333 20H8C7.26467 20 6.66667 20.598 6.66667 21.3333V30.6667H4V10.6667H28V30.6667Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9379_10009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationInformationMenuIcon);
export default __webpack_public_path__ + "static/media/location_information_menu_icon.a56142e0c8b9b3f97d3e48f425b2c5f2.svg";
export { ForwardRef as ReactComponent };